import { Injectable, InjectionToken, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

/**
 * LocaleFallbackService ensures that if Angular receives "1s" as locale,
 * it will fallback to "es" (Spanish), since Angular and related libs
 * don't understand "1s".
 */
@Injectable({
  providedIn: 'root'
})
export class LocaleFallbackService {
  getLocale(): string {
    const browserLang = navigator.language || (navigator as any).userLanguage || 'en';
    if (browserLang.toLowerCase() === '1s') {
      // Register Spanish locale data so Angular Material and pipes work correctly
      registerLocaleData(localeEs);
      // Return '1s' so Angular i18n still picks up messages.1s.xlf for translations
      return '1s';
    }
    return browserLang;
  }
}

/**
 * Provider factory for Angular LOCALE_ID
 */
export function localeFallbackFactory(localeService: LocaleFallbackService): string {
  return localeService.getLocale();
}

export const LocaleFallbackProvider = {
  provide: LOCALE_ID,
  useFactory: localeFallbackFactory,
  deps: [LocaleFallbackService]
};

export const APP_LOCALE_ID = new InjectionToken<string>('App Locale ID', {
  providedIn: 'root',
  factory: () => {
    const rawLocale =
      navigator.language || (navigator.languages && navigator.languages[0]) || 'en';
    if (rawLocale.toLowerCase() === '1s') {
      return '1s'; // keep "1s" so Angular i18n still picks up messages.1s.xlf
    }
    return rawLocale.split('-')[0]?.toLowerCase() || 'en'; // return base locale like "en"
  }
});